export default {
    API_ENDPOINT: 'https://mighty-refuge-14158.herokuapp.com',
    TOKEN_KEY: process.env.REACT_APP_API_KEY
}
